import { useMutation } from '@apollo/client/react';
import { useCallback } from 'react';
import { BACK_IN_STOCK_NOTIFICATION_MUTATION } from './backInStockNotificationMutation.rest';

export const useBackInStockNotificationMutation = (
  sku: string | null | undefined,
  email: string
) => {
  const [mutate, { data, error, loading }] = useMutation(BACK_IN_STOCK_NOTIFICATION_MUTATION);

  const notify = useCallback(() => {
    if (!sku) return;

    return mutate({
      variables: {
        input: {
          email,
          sku: Number(sku)
        }
      }
    });
  }, [email, mutate, sku]);

  return { notify, data, error, loading };
};
